module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraLight.342e516.woff";